import { useEffect, useState } from "react";
import { IconMoon, IconSun } from "./icons";
import { t } from "../i18n";

type Theme = "light" | "dark";
const KEY = "eapace.theme";

function systemTheme(): Theme {
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

function storedTheme(): Theme | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : null;
  } catch {
    return null;
  }
}

export function applyStoredTheme() {
  const tp = storedTheme();
  if (tp) document.documentElement.dataset.theme = tp;
}

export function ThemeToggle({ className = "btn btn-ghost btn-sm" }: { className?: string }) {
  const [theme, setTheme] = useState<Theme>(() => storedTheme() ?? systemTheme());
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);
  const next: Theme = theme === "dark" ? "light" : "dark";
  return (
    <button
      type="button"
      className={className}
      onClick={() => {
        setTheme(next);
        try {
          localStorage.setItem(KEY, next);
        } catch {
          /* sem persistência */
        }
      }}
      aria-label={next === "dark" ? t("Usar tema escuro") : t("Usar tema claro")}
      title={next === "dark" ? t("Tema escuro") : t("Tema claro")}
    >
      {theme === "dark" ? <IconSun width={18} height={18} /> : <IconMoon width={18} height={18} />}
    </button>
  );
}
